import { PICTURE_SHAPES } from "../../Functionalities/pictureShapes";

export const PLACEMENTS = [
  { id: 1, key: "HOME_HERO", label: "Hero banners", screen: "home", shape: "strip" },
  { id: 2, key: "HOME_SQUARE_1", label: "Square banners 1", screen: "home", shape: "square" },
  { id: 3, key: "HOME_SQUARE_2", label: "Square banners 2", screen: "home", shape: "square" },
  { id: 4, key: "HOME_SQUARE_3", label: "Square banners 3", screen: "home", shape: "square" },
  { id: 5, key: "HOME_FOOTER", label: "Footer banner", screen: "home", shape: "strip" },
  { id: 6, key: "SURPLUS_HERO", label: "Surplus hero banners", screen: "surplus", shape: "strip" },
  { id: 7, key: "SURPLUS_SQUARE", label: "Surplus square banners", screen: "surplus", shape: "square" },
];

export const placementsOn = (screen) => PLACEMENTS.filter((p) => p.screen === screen);

export const placementById = (id) => PLACEMENTS.find((p) => p.id === Number(id));

const SPECS = {
  strip: PICTURE_SHAPES.banner,
  square: PICTURE_SHAPES.square,
};

export const pictureSpec = (shape) => SPECS[shape];
